import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";

/** A table in a checklist: the tick, the table, a mono fact. */
export function TableCheckRow({
  on,
  disabled,
  onToggle,
  name,
  fact,
}: {
  on: boolean;
  disabled?: boolean;
  onToggle: () => void;
  name: string;
  fact: string;
}) {
  return (
    // eslint-disable-next-line no-restricted-syntax -- a checklist row: the whole row ticks
    <button
      type="button"
      role="checkbox"
      aria-checked={on}
      disabled={disabled}
      onClick={onToggle}
      className="flex w-full items-center gap-2 rounded-app px-2 enabled:hover:bg-bg-hover text-left text-fg cursor-pointer disabled:cursor-not-allowed disabled:text-fg-muted"
      style={{ minHeight: "var(--item-height)" }}
    >
      <span
        className={`flex flex-none items-center justify-center rounded-app border ${on ? "border-accent bg-accent text-on-accent" : "border-border"}`}
        style={{ width: "0.875rem", height: "0.875rem" }}
      >
        {on && <CheckIcon sx={{ fontSize: 12 }} />}
      </span>
      <TableChartOutlinedIcon sx={{ fontSize: 14 }} className="text-fg-muted" />
      <span className="flex-1 truncate">{name}</span>
      <span className="text-mono-small-muted">{fact}</span>
    </button>
  );
}
